import { SPEEDS } from '../lib/constants';
import type { Speed } from '../lib/types';

/**
 * The stage transport and the per-message REPLAY button would otherwise share
 * the name "REPLAY". Each accessible name still contains its visible label.
 */
const TRANSPORT_LABEL: Record<'PLAY' | 'PAUSE' | 'REPLAY', string> = {
  PLAY: 'PLAY the reply on the stage',
  PAUSE: 'PAUSE the reply on the stage',
  REPLAY: 'REPLAY the reply on the stage from the start',
};

interface ControlsRowProps {
  playLabel: 'PLAY' | 'PAUSE' | 'REPLAY';
  speed: Speed;
  englishOpen: boolean;
  onTogglePlay(): void;
  onSetSpeed(speed: Speed): void;
  onToggleEnglish(): void;
}

export function ControlsRow({
  playLabel,
  speed,
  englishOpen,
  onTogglePlay,
  onSetSpeed,
  onToggleEnglish,
}: ControlsRowProps) {
  return (
    <div className="controls">
      <button
        type="button"
        className="btn-primary"
        aria-label={TRANSPORT_LABEL[playLabel]}
        onClick={onTogglePlay}
      >
        {playLabel}
      </button>

      <div className="speed-group" role="radiogroup" aria-label="Signing speed">
        {SPEEDS.map((option) => (
          <button
            key={option}
            type="button"
            role="radio"
            className="speed-option"
            aria-checked={option === speed}
            onClick={() => onSetSpeed(option)}
          >
            {option}×
          </button>
        ))}
      </div>

      <div className="controls-spacer" />

      <button
        type="button"
        className="english-toggle"
        aria-pressed={englishOpen}
        onClick={onToggleEnglish}
      >
        ENGLISH
      </button>
    </div>
  );
}
